import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';
import { connect } from 'react-redux';
import LazyImg from 'react-lazyload-image';
import './Image.css';
import { convertObjectToArray } from '../../redux/helpers';
import MediaQuery from 'react-responsive';
import Preview from 'react-dnd-preview';

const imageSource = {
  beginDrag(props) {
    return { ...props };
  },
  endDrag(props, monitor, component) {
    if (monitor.didDrop()) {
      component.setState({
        hasDropped: true,
      });
    }
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

const propTypes = {
  thumb: PropTypes.string.isRequired,
  id: PropTypes.number,

  // Injected by React DnD:
  isDragging: PropTypes.bool.isRequired,
  connectDragSource: PropTypes.func.isRequired,
};

class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasDropped: false,
    };
  }

  previewGenerator(itemType, item, style) {
    return <div className="item-list__item" style={style}>
      <img className="ghostImage" src={item.thumb} alt="" />
    </div>;
  }

  isDropped() {
    const { pages, id } = this.props;
    const droppedImages = [];
    convertObjectToArray(pages).map((image) => {
      const IsNotCover = !image.isCover;
      const isNotFrontFlyleaf = !image.isFrontFlyLeaf;
      const isNotBackFlyleaf = !image.isBackFlyLeaf;

      if (IsNotCover && isNotFrontFlyleaf && isNotBackFlyleaf) {
        convertObjectToArray(image.droppedImages).map((imageObject) => {
          if (!droppedImages.includes(imageObject.imageId)) {
            droppedImages.push(imageObject.imageId);
          }
        });
      }
    });
    return droppedImages.includes(id) || false;
  }


  render() {
    const { connectDragSource, thumb } = this.props;

    return connectDragSource(<div className={`Image ${this.isDropped() ? 'selected' : ''}`}>
      <LazyImg
        src={thumb}
        scroller=".GalleryWrapper"
      />
      <MediaQuery maxWidth={991} orientation='portrait'>
        <Preview generator={this.previewGenerator} />
      </MediaQuery>
    </div>);
  }
}

Image.propTypes = propTypes;
Image = DragSource('Image', imageSource, collect)(Image);

export default connect(state => ({
  pages: state.entities.pages.byId,
}
))(Image);



// WEBPACK FOOTER //
// ./src/components/image/Image.jsx